<div class="bg-white rounded-lg shadow-sm p-6 border border-gray-200 h-full">
  <div class="flex items-center mb-5">
    <div
      class="w-5 h-5 rounded-full mr-4 relative"
      [ngClass]="isCompliant ? 'bg-green-500' : 'bg-red-500'"
    >
      <div
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white rounded-full"
      ></div>
    </div>
    <div class="flex items-center gap-2">
      <h2 class="text-xl font-poppins font-semibold text-[#E53935] mb-0">206AB Status</h2>
      <div class="relative group">
        <span
          class="flex h-6 w-6 items-center justify-center rounded-full border border-red-200 bg-red-50 text-xs font-poppins font-semibold text-red-700 cursor-help"
        >
          i
        </span>
        <div
          class="pointer-events-none absolute z-20 mt-2 w-[22rem] max-w-md rounded-xl border border-red-200 bg-white p-4 text-sm font-poppins font-medium leading-relaxed text-slate-800 opacity-0 shadow-2xl transition-opacity duration-200 group-hover:pointer-events-auto group-hover:opacity-100"
        >
          <div class="space-y-3">
            <div class="border-b border-red-100 pb-2">
              <h3 class="text-base font-poppins font-semibold text-red-700">
                Section 206AB Declaration
              </h3>
              <p class="mt-1 text-sm font-poppins text-slate-700">
                A formal statement by the vendor/service provider confirming timely Income Tax
                Return filing so the deductor can apply the correct TDS rate.
              </p>
            </div>
            <div class="border-b border-slate-200 pb-2">
              <h4 class="text-xs font-poppins uppercase tracking-wide text-slate-500">Purpose</h4>
              <p class="mt-1 text-sm font-poppins text-slate-700">
                Helps the deductor verify whether the payee is a "specified person" under Section
                206AB and avoid penalties for under-deduction.
              </p>
            </div>
            <div class="space-y-1">
              <h4 class="text-xs font-poppins uppercase tracking-wide text-slate-500">
                "Specified Person" Criteria (all must apply)
              </h4>
              <ul class="list-disc space-y-1 pl-5 text-sm font-poppins text-slate-700">
                <li>
                  No ITR filed for each of the last two assessment years (past the due dates).
                </li>
                <li>Aggregate TDS + TCS was ₹50,000 or more in each of those years.</li>
                <li>Result: higher TDS is triggered.</li>
              </ul>
            </div>
            <div
              class="rounded-lg border border-amber-200 bg-amber-50 p-3 text-xs font-poppins font-semibold text-amber-900"
            >
              If tagged as a "specified person", deduct TDS at the higher of twice the normal rate
              or 5%.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="space-y-3">
    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">PAN Status</span>
      <span
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold"
        [ngClass]="panStatusClass"
      >
        {{ panStatusDisplay }}
      </span>
    </div>

    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">Financial Year</span>
      <span class="font-poppins text-[#0E1116]">{{ financialYearDisplay }}</span>
    </div>

    <div class="flex justify-between items-center py-3 border-b border-gray-100">
      <span class="font-poppins font-medium text-[#4B4B4B]">206AB Status</span>
      <span
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold"
        [ngClass]="status206ABClass"
      >
        {{ status206ABDisplay }}
      </span>
    </div>
  </div>
</div>
